<script setup>

import { onMounted, computed } from "vue";
import { useProductsStore } from '@/stores/products';
import ProductFilters from "@/components/ProductFilters.vue";
import ButtonToolbar from "@/components/ButtonToolbar.vue";
import { useRouter, useRoute } from "vue-router";


const productsStore = useProductsStore();
const router = useRouter();
const route = useRoute();

function goToProductByIndex() {
  router.push(productsStore.initialProducts[productsStore.currentProductIndex - 1].url)
}

function goToNextProduct() {
  productsStore.goToNextProduct()
  goToProductByIndex()
}

function goToPrevProduct() {
  productsStore.goToPrevProduct()
  goToProductByIndex()
}

function goToFirstProduct(){
  productsStore.goToFirstProduct()
  goToProductByIndex()
}

const isProductPage = computed(() => {
  return !!route.params.id
})

onMounted(async () => {
  await productsStore.fetchProductsWithFilters();  // Call the fetchProducts action
  addSkinStyles(`${productsStore.domain.url}/skin/${productsStore.domain.skin}`)
  // @TODO спитати звідки береться цей файл і як правильно його додавати
  addSkinStyles('//zityad.com/biz_css/pieckert/newp.css?2222')
});

function addSkinStyles(url) {
  // Normalize the URL by resolving relative URLs (if necessary)
  const normalizedUrl = new URL(url, window.location.origin).href;  // Resolves relative URLs

  // Check if the link is already added to avoid duplicates
  const existingLink = document.querySelector(`link[href="${normalizedUrl}"]`);
  if (!existingLink) {
    const link = document.createElement('link');
    link.rel = 'stylesheet';
    link.href = url;
    document.head.appendChild(link);
  }
}
</script>

<template>
  <div :class="productsStore.pageInfo?.isWide ? 'wide wide-page' : 'default default-page'">
    <div :class="`container${productsStore.section.full_width ? '-fluid' : ''}`">
      <div v-if="!productsStore.filterAttributes">Loading...</div>
      <div v-else class="section product-section position-relative">
        <!--      @TODO sticky conditional-->
        <div class="product-filter-outer sticky" v-if="productsStore.filterAttributes?.attributes?.length > 0">
          <div>
            <product-filters :filter-data="productsStore.filterAttributes"></product-filters>
            <button-toolbar
              v-if="isProductPage"
              :products-length="productsStore.initialProducts.length"
              :product-index="productsStore.currentProductIndex"
              @go-to-next-product="goToNextProduct"
              @go-to-prev-product="goToPrevProduct"
              @go-to-first-product="goToFirstProduct"
            ></button-toolbar>
          </div>
        </div>
        <div class="current-product-view" :class="`list-view-${productsStore.section.parameters?.listView}`">
          <!--        <product-list class="list" :products-data="productsStore.productsData" :products="productsStore.products"></product-list> &lt;!&ndash; Pass products to ProductList &ndash;&gt;-->
          <!--        @TODO Other templates?-->
          <router-view/>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped lang="scss">
//.sticky {
//  position: sticky;
//  top: 0;
//  z-index: 9;
//}

.position-relative {
  position: relative;
}

</style>